import {loop, Effects} from 'redux-loop';
import _ from 'lodash';
import {
  TOGGLE_ARTICLE_MODAL,
  SET_IS_READ,
  SET_ARTICLE,
  FETCH_MLT_DATA,
  FETCH_MLT_DATA_SUCCESS,
  TOGGLE_PREVIEW_MODAL,
  TOOGLE_SETTING_MODAL,
  CHANGE_SETTING_MODAL,
  TOOGEL_QC_MODAL,
  MODIFY_CODING_MEDIA,
  TOOGEL_TESTING_MODAL,
  FETCH_COMMENT,
  FETCH_COMMENT_SUCCESS} from './actions';
import {fetchMltData, fetchCommentData} from './tasks';

const initialState = {
  dataIsRead: [],
  articleModal: {
    isOpen: false,
    mltData: {isLoading: false,},
    commentData: {isLoading: false},
    data: {}
  },
};

export default (state = initialState, action) => {
  if (action.type === TOGGLE_ARTICLE_MODAL) {
    const isRead = _.uniq([...state.dataIsRead, action.data.globalId])
    return loop({
      ...state,
      articleModal: {
        ...state.articleModal,
        isOpen: !state.articleModal.isOpen,
        data: action.data,
      },
      dataIsRead: [...isRead]
    },
      Effects.none()
    );
  };

  if (action.type === SET_IS_READ) {
    const isRead = _.uniq([...state.dataIsRead, action.data.globalId])
    return loop({
      ...state,
      dataIsRead: [...isRead]
    },
      Effects.none()
    );
  }

  if (action.type === SET_ARTICLE) {
    const isRead = _.uniq([...state.dataIsRead, action.data.globalId])
    return loop({
      ...state,
      articleModal: {
        ...state.articleModal,
        data: action.data,
      },
      dataIsRead: [...isRead]
    },
      Effects.none()
    );
  }

  if (action.type === FETCH_MLT_DATA) {
    return loop({
      ...state,
      articleModal: {
        ...state.articleModal,
        mltData: {...state.articleModal.mltData, isLoading: true},
      }
    },
      Effects.promise(fetchMltData, action.data)
    )
  }

  if (action.type === FETCH_MLT_DATA_SUCCESS) {
    return loop({
      ...state,
      articleModal: {
        ...state.articleModal,
        mltData: {data:action.data, isLoading: false},
      }
    },
      Effects.none()
    )
  }

  if (action.type === FETCH_COMMENT) {
    return loop({
      ...state,
      articleModal: {
        ...state.articleModal,
        commentData: {
          ...state.articleModal.commentData,
          isLoading: true
        },
      },
    },
      Effects.promise(fetchCommentData, action.data)
    )
  }

  if (action.type === FETCH_COMMENT_SUCCESS) {
    return loop({
      ...state,
      articleModal: {
        ...state.articleModal,
        commentData: {
          isLoading: false,
          data: action.data
        },
      },
    },
      Effects.none()
    )
  }

  return loop(state, Effects.none());
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/modal/reducer.js
 **/